import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import { initTheme } from './theme/themes'
import { initStyling } from './theme/userStyling'
import App from './App.tsx'

initTheme()
initStyling()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
